<template>
  <div class="route-section__route-list flex flex-column-reverse">
    <div
      v-for="(layer, index) in props.routeLayers"
      :key="index"
      :class="getLayerClasses(layer)"
      @click="selectRouteForDetails(layer)"
    >
      <div class="flex flex-column gap-1">
        <span class="font-bold text-800">{{ layer.routeDescription }}</span>
        <span class="text-800">{{ layer.pointsEnumeration }}</span>
        <div :class="routeColorClass(layer)"></div>
      </div>
      <div class="flex flex-column gap-1">
        <Button
          v-tooltip="'Eliminar ruta'"
          class="mc-row__button align-self-top"
          raised
          rounded
          @click="removeRoute(layer.id)"
        >
          <span class="pi pi-times"></span>
        </Button>
        <Button
          v-tooltip="'Enfocar ruta'"
          class="mc-row__button align-self-bottom"
          raised
          rounded
          @click="focusRoute(layer)"
        >
          <span class="material-icons">location_on</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup>
import Button from 'primevue/button';

const props = defineProps({
  routeLayers: {
    type: Array,
    default: () => [],
  },
  selectedRouteId: {
    type: String,
    default: () => null,
  },
});
const emit = defineEmits(['selectRouteDetails', 'removeRoute', 'focusRoute']);

function routeColorClass(layer) {
  const baseClass = 'bg-distinct-color';
  const colorIndex = layer?.colorIndex;
  if (colorIndex != null) {
    return baseClass + ' bg-distinct-color--' + (colorIndex + 1);
  }
  return baseClass + ' bg-distinct-color--1';
}
function getLayerClasses(layer) {
  const classes = ['m-0 mb-2 mr-2 layer-container gap-5'];
  if (layer.id === props.selectedRouteId) {
    classes.push('layer-container-selected');
  }
  return classes;
}
function focusRoute(layer) {
  emit('focusRoute', layer);
}
function removeRoute(id) {
  emit('removeRoute', id);
}
async function selectRouteForDetails(data) {
  emit('selectRouteDetails', data);
}

</script>

<style lang="scss" scoped>
@import "@/styles/custom-colors.scss";

.layer-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 8px 8px 8px 0;
  padding: 8px 12px;
  border: .5px solid #ccc;
  background-color: white;
  border-radius: 8px;
  transition: background-color .2s ease;
}
.layer-container:hover {
  background-color: $subtle-blue_60;
}
.layer-container-selected {
  background-color: $container-background-gray;
}
</style>
